import { render } from "./permission_management.html?vue&type=template&id=27a09470&external"
import script from "./permission_management.js?vue&type=script&lang=js&external"
export * from "./permission_management.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__